import axios from 'axios'
import { RequestGenerateLoraType } from '../../types/media_type'
import moment from 'moment'
import { RcFile } from 'antd/es/upload'

export default class CommonAPIs {
  static baseURL = 'https://jp-headswap-prod-api.creativelink.ai/v2'

  static endpoints = {
    checkpoint: this.baseURL + '/train-lora/lora/checkpoints',
    processingJobList: this.baseURL + '/train-lora/lora/processing-job',
    mediaStatusJob: this.baseURL + '/train-lora/lora',
    requestTrainLora: this.baseURL + '/train-lora/lora',
    loraHistory: this.baseURL + '/train-lora/lora',
    imageArchiveTrainLora: this.baseURL + '/train-lora/lora/images-archive',
    newCheckpoint: this.baseURL + '/train-lora/lora/lora-by-user',
    imageArchive: this.baseURL + '/ai-img/img-archive',
    renderImg2Img: this.baseURL + '/ai-img/render-img2img-for-web',
    renderImg2ImgJob: this.baseURL + '/ai-img/job-data',
    renderHistory: this.baseURL + '/ai-img/media-by-user',
    processingRenderJobList: this.baseURL + '/ai-img/proccessing-job'
  }

  static headers = {
    'Content-Type': 'multipart/form-data',
    Accept: 'application/json'
  }

  static async getCheckpointList() {
    try {
      let response = await axios.get(CommonAPIs.endpoints.checkpoint, {
        headers: this.headers
      })
      return Promise.resolve(response.data)
    } catch (error) {
      return Promise.reject(error)
    }
  }

  static async getNewCheckpoint() {
    try {
      let response = await axios.get(CommonAPIs.endpoints.newCheckpoint + '?user_id=1', {
        headers: this.headers
      })
      return Promise.resolve(response.data)
    } catch (error) {
      return Promise.reject(error)
    }
  }

  static async checkStatusMediaJob(jobID: number) {
    try {
      const url = `${CommonAPIs.endpoints.mediaStatusJob}/${jobID}/status?user_id=1`
      let response = await axios.get(url, {
        headers: this.headers
      })
      return Promise.resolve(response.data?.data ?? [])
    } catch (error) {
      return Promise.reject(error)
    }
  }

  static async requestTrainLora(inputDt: RequestGenerateLoraType, gender: number, images: string[]) {
    //    const handleConvertBase64ToFile = (base64: string) => {
    //      const filename = 'image.jpg'
    //      const mimeType = 'image/jpeg'
    //      // Split the base64 string to get the data part
    //      const dataPart = base64.split(',')[1]
    //
    //      // Convert the base64 data to a Blob
    //      const blob = atob(dataPart)
    //      const arrayBuffer = new ArrayBuffer(blob.length)
    //      const uint8Array = new Uint8Array(arrayBuffer)
    //      for (let i = 0; i < blob.length; i++) {
    //        uint8Array[i] = blob.charCodeAt(i)
    //      }
    //
    //      // Create a Blob
    //      const blobObject = new Blob([uint8Array], { type: mimeType })
    //
    //      // Create a File
    //      const file = new File([blobObject], filename, { type: mimeType })
    //
    //      return file
    //    }
    //    console.log('checkPointSelected::', inputDt?.checkPointSelected)
    //    console.log('loraName:', inputDt?.name)

    const formData = new FormData()
    formData.append('name', inputDt?.name)
    formData.append('checkpoint', inputDt?.checkPointSelected)
    formData.append('user_id', '1')
    formData.append('gender', `${gender}`)

    //for (var i = 0; i < inputDt?.fileListBase64.length; i++) {
    //  console.log(`fileListBase64[${i}].des::`, handleConvertBase64ToFile(inputDt?.fileListBase64[i]?.url))
    //  formData.append(`images[${i}]`, handleConvertBase64ToFile(inputDt?.fileListBase64[i]?.url))
    //}
    for (let index = 0; index < images.length; index++) {
      formData.append(`images[${index}]`, images[index])
    }

    try {
      let response = await axios.post(CommonAPIs.endpoints.requestTrainLora, formData, {
        headers: {
          ...this.headers
        }
      })
      return Promise.resolve(response.data?.data)
    } catch (error) {
      return Promise.reject(error)
    }
  }

  static async getLoraHistory(startDate: string | Date, endDate: string | Date, page: number | string) {
    const startD = moment(startDate).format('YYYY-MM-DD')
    const endD = moment(endDate).format('YYYY-MM-DD')

    try {
      const url = `${CommonAPIs.endpoints.loraHistory}?user_id=1&start_date=${startD}&end_date=${endD}&page=${page}`
      let response = await axios.get(url, {
        headers: this.headers
      })
      return Promise.resolve(response.data?.data ?? [])
    } catch (error) {
      return Promise.reject(error)
    }
  }

  static async getLoraProcessing() {
    try {
      let response = await axios.get(CommonAPIs.endpoints.processingJobList, {
        headers: this.headers
      })
      return Promise.resolve(response.data?.data ?? [])
    } catch (error) {
      return Promise.reject(error)
    }
  }

  static async saveLoraImgs(base46Images: any) {
    const formData = new FormData()

    for (let index = 0; index < base46Images.length; index++) {
      formData.append(`images[${index}]`, base46Images[index].url)
    }

    try {
      let response = await axios.post(CommonAPIs.endpoints.imageArchiveTrainLora, formData, {
        headers: this.headers
      })
      return Promise.resolve(response.data.data)
    } catch (error) {
      return Promise.reject(error)
    }
  }

  static async saveImgs(imageFile: RcFile, faceImageFile: RcFile) {
    const formData = new FormData()
    formData.append('background_image', imageFile)
    formData.append('face_image', faceImageFile)

    try {
      let response = await axios.post(CommonAPIs.endpoints.imageArchive, formData, {
        headers: this.headers
      })
      return Promise.resolve(response.data)
    } catch (error) {
      return Promise.reject(error)
    }
  }

  static async renderImg2Img(background_url: string, face_url: string) {
    try {
      let response = await axios.post(
        CommonAPIs.endpoints.renderImg2Img,
        {
          'background_url': background_url,
          'face_url': face_url,
          'user_id': 'DYM'
        },
        {
          headers: {
            'Content-Type': 'application/json',
            Accept: 'application/json'
          }
        }
      )
      return Promise.resolve(response.data?.data)
    } catch (error) {
      return Promise.reject(error)
    }
  }

  static async renderImg2ImgJob(jobID: number) {
    try {
      const url = `${CommonAPIs.endpoints.renderImg2ImgJob}/${jobID}/status?user_id=DYM`
      let response = await axios.get(url, {
        headers: this.headers
      })
      return Promise.resolve(response.data?.data ?? [])
    } catch (error) {
      return Promise.reject(error)
    }
  }

  static async getRenderHistory(startDate: string | Date, endDate: string | Date, page: number | string) {
    const startD = moment(startDate).format('YYYY-MM-DD')
    const endD = moment(endDate).format('YYYY-MM-DD')

    try {
      const url = `${CommonAPIs.endpoints.renderHistory}?user_id=DYM&start_date=${startD}&end_date=${endD}&page=${page}`
      let response = await axios.get(url, {
        headers: this.headers
      })
      return Promise.resolve(response.data?.data ?? [])
    } catch (error) {
      return Promise.reject(error)
    }
  }

  static async getRenderProcessing() {
    try {
      let response = await axios.get(`${CommonAPIs.endpoints.processingRenderJobList}?user_id=DYM`, {
        headers: this.headers
      })
      return Promise.resolve(response.data?.data ?? [])
    } catch (error) {
      return Promise.reject(error)
    }
  }
}
